import { motion } from 'framer-motion';
import clsx from 'clsx';

type Props = {
  level: number; // 0..1 RMS amplitude
  status: 'connecting' | 'live' | 'paused' | 'ended' | 'error';
  size?: number;
};

export function ListeningOrb({ level, status, size = 200 }: Props) {
  const scale = 1 + Math.min(0.18, level * 0.4);
  const tone =
    status === 'live'
      ? 'from-accent via-cyan to-success'
      : status === 'paused'
        ? 'from-warning via-warning to-warning'
        : status === 'error'
          ? 'from-danger via-danger to-danger'
          : 'from-accent to-cyan';

  return (
    <div
      className="relative grid place-items-center"
      style={{ width: size, height: size }}
    >
      <motion.div
        aria-hidden
        className={clsx(
          'absolute inset-0 rounded-full blur-3xl opacity-70 bg-gradient-to-br',
          tone,
        )}
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 14, ease: 'linear' }}
      />
      <motion.div
        animate={{ scale }}
        transition={{ type: 'spring', stiffness: 240, damping: 18, mass: 0.4 }}
        className={clsx(
          'relative grid place-items-center rounded-full bg-gradient-to-br shadow-glow',
          tone,
        )}
        style={{ width: size * 0.7, height: size * 0.7 }}
      >
        <div
          className="rounded-full bg-bg-0/85 backdrop-blur-xl"
          style={{ width: size * 0.46, height: size * 0.46 }}
        />
        <div
          className="absolute rounded-full bg-white/95 shadow-glow"
          style={{ width: size * 0.14, height: size * 0.14, transform: `translate(-${size * 0.06}px, -${size * 0.04}px)` }}
        />
      </motion.div>
      {status === 'live' && (
        <motion.span
          className="absolute size-3 rounded-full bg-danger"
          style={{ top: 6, right: 6 }}
          animate={{ opacity: [0.4, 1, 0.4] }}
          transition={{ repeat: Infinity, duration: 1.4 }}
          aria-hidden
        />
      )}
    </div>
  );
}
